import FormFields from '@/modules/FormFields';
import FlexColumns from '@/components/FlexColumns';
import GridFill from '@/modules/GridFill';
import GridSnap from '@/modules/GridSnap';
import HeroSlideshow from '@/components/HeroSlideshow';
import Intersection from '@/modules/Intersection';
import LazySrc from '@/modules/LazySrc';
import LoadMore from '@/modules/LoadMore';
import MenuItems from '@/modules/MenuItems';
import MetaText from '@/modules/MetaText';
import MobileNav from '@/components/MobileNav';
import Modal from '@/modules/Modal';
import NavOffset from '@/modules/NavOffset';
import ScrollAnimations from '@/modules/ScrollAnimations';
import { sliders } from '@/modules/Sliders';
import SmoothScroll from 'smooth-scroll/dist/smooth-scroll.polyfills.js';
import StickyNav from '@/components/StickyNav';
import TypingAnimation from '@/modules/TypingAnimation';

document.addEventListener('DOMContentLoaded', function () {
    const smoothScroll = new SmoothScroll('a[href*="#"]', {
        speed: 800,
    });

    FlexColumns.init({
        selector: `[data-js="flex-cols"]`,
    });

    FormFields.init({
        selector: `.wpcf7 .form-field`,
    });

    GridFill.init({
        selector: `[data-js="grid-fill"]`,
    });

    GridSnap.init({
        selector: `[data-js="snap-to-grid"]`,
    });

    HeroSlideshow.init({
        selector: `[data-js="slideshow"]`,
    });

    LazySrc.init({
        selector: `[data-lazy-src]`,
    });

    LoadMore.init({
        selector: `[data-js="ajax-button"]`,
    });

    Modal.init({
        selector: `[data-modal-id]`,
    });

    MenuItems.init({
        selector: `.menu-item.is-top-level`,
    });

    MobileNav.init({
        selector: `.c-mobile-nav`,
    });

    MetaText.init({
        selector: `[data-text-content]`,
    });

    NavOffset.init({
        selector: `.c-nav`,
    });

    StickyNav.init({
        selector: `.c-nav`,
    });

    TypingAnimation.init();

    Intersection.init({
        selector: '[data-reveal]',
    });

    ScrollAnimations.init({
        selector: `[data-reveal][data-animate]`,
    });

    sliders.init();
});

window.addEventListener('load', () => {});
